module.exports = __webpack_public_path__ + "img/ticket10.a4ae4d6e.png";